import type { PrimitiveProps } from "reka-ui";
import type { Simplify } from "type-fest";
import { computed, type ComputedRef, type HTMLAttributes } from "vue";

export type ClassProps = {
	class?: HTMLAttributes["class"];
};

export type BasePrimitiveProps = ClassProps & PrimitiveProps;

export const BaseColor = {
	default: "default",
	neutral: "neutral",
	primary: "primary",
	secondary: "secondary",
	accent: "accent",
	success: "success",
	warning: "warning",
	error: "error",
} as const;
export type BaseColor = (typeof BaseColor)[keyof typeof BaseColor];

/**
 * Remove the class props from the props object
 *
 * note: we use Simplify to break to complexe vue type of the defineProps return.
 * Sometime, it create errors in the typescript compilation otherwise.
 */
export function useDelegatedProps<T extends ClassProps, const TOthers extends (keyof T)[]>(
	props: T,
	others?: TOthers
): ComputedRef<Omit<Simplify<T>, "class">> {
	return computed(() => {
		const { class: _, ...rest } = props;

		if (others != null) {
			for (const other of others) {
				delete (rest as any)[other];
			}
		}

		return rest as any;
	});
}
